/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_MeatInputs */

const en_store_meat = /** @type {(inputs: Store_MeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meat`)
};

const de_store_meat = /** @type {(inputs: Store_MeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fleisch`)
};

/**
* | output |
* | --- |
* | "Meat" |
*
* @param {Store_MeatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_meat = /** @type {((inputs?: Store_MeatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_MeatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_meat(inputs)
	return en_store_meat(inputs)
});